<template>
  <t-layout>
    <t-aside>
      <Header></Header>
    </t-aside>
    <t-layout>
      <t-content style="min-height: 100vh;">
        <div style="padding:20px;">
          <div class="flex space-between">
            <div><span class="c-main fs-26 fw-600">A组列表</span></div>
            <div><t-button @click="openDialog">添加</t-button></div>
          </div>
          <div class="mt-20">
            <t-table
                row-key="index"
                :data="listData"
                :columns="columns"
                :stripe="stripe"
                :bordered="bordered"
                :hover="hover"
                :table-layout="tableLayout ? 'auto' : 'fixed'"
                :size="size"
                :show-header="showHeader"
                cell-empty-content="-"
                resizable
                lazy-load
            >
              <template #cover="{ row }">
                <img v-for="item in row.cover" :src="item.url" alt="" style="width:100px;" />
              </template>

              <template #active_rate="{ row }">
                <t-progress :percentage="row.active_rate" label />
              </template>

              <template #level="{ row }">
                <span v-if="row.level == 'Basic'">入门版</span>
                <span v-if="row.level == 'Standard'">标准版</span>
                <span v-if="row.level == 'Premium'">高级版</span>
              </template>

              <template #level_account="{ row }">
                <span>{{row.account_count}} / {{row.level_account}}</span>
              </template>



              <template #today_active="{ row }">
                <t-tag v-if="row.today_active" theme="success" variant="light">活跃</t-tag>
              </template>

<!--              <template #type-slot-operate="{ col, row }">-->
<!--                <t-button size="small" @click="viewAct(row)">查看</t-button>-->
<!--                <a :href="'/productAdd?id='+row.id"><t-button size="small" class="ml-10"  theme="warning">修改</t-button></a>-->
<!--                <t-button size="small" class="ml-10" theme="danger" @click="deleteProduct(row)">删除</t-button>-->
<!--                <t-button size="small" class="ml-10" theme="danger" @click="englishSet(row)">英语翻译</t-button>-->
<!--              </template>-->


            </t-table>

            <div style="margin-top: 16px; display: flex; justify-content: flex-end">
              <SimplePage :pagination="pagination" @change="rehandlePageChange" storage-key="storeList" />
            </div>
          </div>

          <AddStoreDialog
              v-model:visible="visible"
              @success="handleSuccess"
          />
        </div>
      </t-content>
    </t-layout>
  </t-layout>
</template>
<script setup>
import Header  from '@/components/header.vue'
import {onMounted, ref} from "vue";
import {aGroupListApi} from "@/api/agroup";
import SimplePage from "@/components/SimplePage.vue";
import AddStoreDialog from "@/views/aGroup/AddStoreDialog.vue";
const visible = ref(false)

const columns = ref([
  {colKey: 'cover', title: '店铺logo',cell: 'cover',},
  {colKey: 'store_no', title: '店铺编号',width: 220},
  {colKey: 'store_name', title: '店铺名称',},
  { colKey: 'user_name', title: '店长名称', },
  { colKey: 'phone', title: '店长手机号', },
  { colKey: 'level', title: '等级', cell: 'level' },
  { colKey: 'level_time', title: '等级到期时间', },
  { colKey: 'use_days', title: '使用天数', },
  { colKey: 'level_account', title: '账户容量',cell: 'level_account' },
  { colKey: 'store_from', title: '来源', },
  { colKey: 'active_rate', title: '近一个月活跃度', cell: 'active_rate',},
  { colKey: 'today_active', title: '今日活跃', cell: 'today_active',},
]);

const stripe = ref(true);
const bordered = ref(true);
const hover = ref(false);
const tableLayout = ref(false);
const size = ref('medium');
const showHeader = ref(true);

const handleSuccess = () => {
  console.log("保存成功，可刷新列表")
}
const openDialog = () => {
  visible.value = true
}

onMounted(() => {
  aGroupList()
})

const listData = ref([]);
const getStoredPageSize = () => {
  try {
    const stored = localStorage.getItem('table_page_size_storeList')
    if (stored) {
      const pageSize = parseInt(stored)
      if (!isNaN(pageSize) && pageSize > 0) {
        return pageSize
      }
    }
  } catch (error) {
    console.error('读取分页配置失败:', error)
  }
  return 20
}

const rehandlePageChange = (pageInfo) => {
  pagination.value.current = pageInfo.current
  pagination.value.pageSize = pageInfo.pageSize
  aGroupList()
}

const pagination = ref({
  defaultPageSize: 20,
  total: 0,
  defaultCurrent: 1,
  current: 1,
  pageSize: getStoredPageSize(),
})

const aGroupList = () => {
  let param = {
    page: pagination.value.current,
    page_size: pagination.value.pageSize,
    cat_id:0
  }
  aGroupListApi(param).then(res => {
    if (res.data.code == 200) {
      listData.value = [];
      let data = res.data.data

      for (let i=0; i<data.list.length; i++) {
        if (data.list[i].cover !== "" && data.list[i].cover !== null) {
          data.list[i].cover = JSON.parse(data.list[i].cover)
        }

        listData.value.push({
          index: i + 1,
          store_name: data.list[i].store_name,
          store_id: data.list[i].store_id,
          phone: data.list[i].phone,
          user_name: data.list[i].user_name,
          top_id: data.list[i].top_id,
          cover: data.list[i].cover,
          store_no: data.list[i].store_no,
          level: data.list[i].level,
          level_time: formatTime(data.list[i].level_time),
          level_account: data.list[i].level_account,
          store_from: data.list[i].store_from,
          active_rate: data.list[i].active_rate,
          today_active: data.list[i].today_active,
          use_days: data.list[i].use_days,
          account_count: data.list[i].account_count,
        });
      }

      pagination.value.pageSize = data.page_size
      pagination.value.total = data.total
      pagination.value.current = data.page
    }
  })
}

const formatTime = (timestamp) => {
  if (timestamp != "") {
    const date = new Date(timestamp * 1000) // 如果是秒级时间戳
    return date.toLocaleString()
  }

  return ""

}

</script>